import isArray from './is-array';
import isNil from './is-nil';
export default (function (data, name) {
    var rst = [];
    var tmpMap = {};
    for (var i = 0; i < data.length; i++) {
        var obj = data[i];
        var value = obj[name];
        if (!isNil(value)) {
            // flatten
            if (!isArray(value)) {
                value = [value];
            }
            for (var j = 0; j < value.length; j++) {
                var val = value[j];
                // unique
                if (!tmpMap[val]) {
                    rst.push(val);
                    tmpMap[val] = true;
                }
            }
        }
    }
    return rst;
});
//# sourceMappingURL=values-of-key.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/esm/values-of-key.js
// module id = 534
// module chunks = 3